import React from 'react';
import { ArrowRight, Clock } from 'lucide-react';
import { BakeryEvent } from '../types/event';
interface EventRowProps {
  event: BakeryEvent;
  onSignup: (event: BakeryEvent) => void;
}
export function EventRow({
  event,
  onSignup
}: EventRowProps) {
  const date = new Date(`${event.date}T12:00:00`);
  const day = date.getDate();
  const month = date.toLocaleDateString('sv-SE', {
    month: 'short'
  });
  const weekday = date.toLocaleDateString('sv-SE', {
    weekday: 'long'
  });
  const needsSignup = !!event.signup;
  return <article className="grid grid-cols-[72px_1fr] md:grid-cols-[112px_1fr_auto] gap-x-5 md:gap-x-10 gap-y-4 py-8 md:py-10 border-t border-[#7C8062]/20" data-id="element-451" data-mp="1ksxdr30xfbiu">
      <div className="flex flex-col items-start" data-id="element-452" data-mp="1atq5gu91u72l">
        <span className="font-serif text-5xl md:text-6xl leading-none text-[#1A1A1A]" data-id="element-453" data-mp="1aswuti6yyxf6">
          {day}
        </span>
        <span className="mt-1 text-sm font-medium text-[#7C8062]" data-id="element-454" data-mp="4exl8d4euo5m">
          {month.replace('.', '')}
        </span>
      </div>

      <div className="min-w-0" data-id="element-455" data-mp="1ulb5cw3w502m">
        <p className="text-sm text-[#1A1A1A]/60 mb-1.5 capitalize" data-id="element-456" data-mp="1ul1c8znjucsp">
          {weekday} · {event.category}
        </p>
        <h3 className="font-serif text-2xl md:text-3xl text-[#1A1A1A] leading-tight mb-3" data-id="element-457" data-mp="1zj2ujid5i834">
          {event.title}
        </h3>
        <p className="text-[#1A1A1A]/75 leading-relaxed max-w-xl" data-id="element-458" data-mp="1kp7tgyj8ln2h">
          {event.description}
        </p>
        {event.details && event.details.length > 0 && <ul className="mt-3 space-y-1" data-id="element-459" data-mp="1bu1lbswhusws">
            {event.details.map(d => <li key={d} className="text-sm font-medium text-[#1A1A1A]/85 pl-3 border-l-2 border-[#C4993D]" data-id="element-460" data-mp="1gml9fjst56fu">
                {d}
              </li>)}
          </ul>}
        <div className="mt-4 flex flex-wrap items-center gap-x-5 gap-y-1 text-sm text-[#1A1A1A]/70" data-id="element-461" data-mp="16w00p3jf6lj7">
          <span className="inline-flex items-center gap-1.5" data-id="element-462" data-mp="swqv0xsub9th">
            <Clock className="w-4 h-4 text-[#7C8062]" aria-hidden="true" data-id="element-463" data-mp="wwhj2tqzfbub" />
            {event.time}
          </span>
          {event.price && <span className="font-medium text-[#1A1A1A]" data-id="element-464" data-mp="2zmanqcf8s3di">{event.price}</span>}
          {event.spots && <span data-id="element-465" data-mp="2urocc995uatf">{event.spots}</span>}
        </div>
      </div>

      <div className="col-start-2 md:col-start-3 md:self-center" data-id="element-466" data-mp="2pv6dtr4fb8pj">
        {needsSignup ? <button onClick={() => onSignup(event)} className="inline-flex items-center gap-2 px-6 py-3 bg-[#C4993D] text-[#F2EDE4] rounded-full text-sm font-medium hover:bg-[#A8832F] transition-colors whitespace-nowrap" data-id="element-467" data-mp="2kwmodgqmfesf">
            {event.ctaLabel ?? 'Anmäl dig'}
            <ArrowRight className="w-4 h-4" aria-hidden="true" data-id="element-468" data-mp="38jl246ncw8mn" />
          </button> : <span className="inline-flex px-4 py-2 rounded-full bg-[#7C8062]/10 text-sm font-medium text-[#7C8062] whitespace-nowrap" data-id="element-469" data-mp="34ij0jj5yvkhi">
            Kom förbi
          </span>}
      </div>
    </article>;
}